import { emptyArr, emptyObj } from '@beef/utils';

export const getFTTB = (state) => state.internet || emptyObj;
export const getFTTBConnectedDevices = (state) => getFTTB(state).connectedDevices || emptyArr;
export const getFTTBLogin = (state) => getFTTB(state).login;
export const getFTTBLoginAlias = (state) => getFTTB(state).alias;
export const getFTTBSubscriptionFee = (state) => getFTTB(state).subscriptionFee;
export const getFTTBError = (state) => getFTTB(state).error;
export const getFTTBspeedUps = (state) => getFTTB(state).speedUps || emptyArr;
export const getFTTBTurboSpeedUp = (state) => getFTTB(state).turboSpeedUp || emptyObj;
export const getFTTBIsSpeedUpAvailable = (state) => !!getFTTB(state).isSpeedUpAvailable;
export const getFTTBIsActive = (state) => !!getFTTB(state).isActive;
export const getApplicationIsConvergent = (state) => !!state.application?.isConvergent;
